import _definePage_default_0 from '/opt/buildhome/repo/src/pages/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/opt/buildhome/repo/src/pages/about.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/opt/buildhome/repo/src/pages/login.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/opt/buildhome/repo/src/pages/rate/:id.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/opt/buildhome/repo/src/pages/settings.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/opt/buildhome/repo/src/pages/top-rated.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/opt/buildhome/repo/src/pages/verify-email.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/',
      name: 'Home',
      component: () => import('/opt/buildhome/repo/src/pages/index.vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  _mergeRouteRecord(
    {
      path: '/about',
      name: 'About',
      component: () => import('/opt/buildhome/repo/src/pages/about.vue'),
      /* no children */
    },
    _definePage_default_2
  ),
  _mergeRouteRecord(
    {
      path: '/login',
      name: 'Login',
      component: () => import('/opt/buildhome/repo/src/pages/login.vue'),
      /* no children */
    },
    _definePage_default_3
  ),
  {
    path: '/rate',
    /* internal name: '/rate' */
    /* no component */
    children: [
      {
        path: '',
        name: '/rate/',
        component: () => import('/opt/buildhome/repo/src/pages/rate/index.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: ':id',
          name: 'RateStore',
          component: () => import('/opt/buildhome/repo/src/pages/rate/:id.vue'),
          /* no children */
        },
        _definePage_default_4
      )
    ],
  },
  {
    path: '/register',
    name: '/register',
    component: () => import('/opt/buildhome/repo/src/pages/register.vue'),
    /* no children */
  },
  _mergeRouteRecord(
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('/opt/buildhome/repo/src/pages/settings.vue'),
      /* no children */
    },
    _definePage_default_5
  ),
  _mergeRouteRecord(
    {
      path: '/top-rated',
      name: 'TopRated',
      component: () => import('/opt/buildhome/repo/src/pages/top-rated.vue'),
      /* no children */
    },
    _definePage_default_6
  ),
  _mergeRouteRecord(
    {
      path: '/verify-email',
      name: 'VerifyEmail',
      component: () => import('/opt/buildhome/repo/src/pages/verify-email.vue'),
      /* no children */
    },
    _definePage_default_7
  )
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

